import React from 'react';
import TimeSlot from 'src/components/ServiceRequestForm/TimeSlot/TimeSlot';

export interface DetailsSchedulingProps {
  show: boolean;
  onChangeSchedule: (selected: any) => void;
}

const DetailsScheduling = ({ show, onChangeSchedule }: DetailsSchedulingProps) => {
  if (!show) {
    return null;
  }

  return (
    <TimeSlot
      onSelectionChange={(selected: any) => onChangeSchedule(selected)}
      serviceRequestForm
    />
  );
};

export default DetailsScheduling;